<template>
    <div>
        <component 
            :is="componentName"
            :default-data="dimensionModal"
            :optionFieldsList="optionFieldsList"
            :dimension="dimension"
            ref="componentRef"
        />
        <div class="tac mt20">
			<el-button type="default"  class="action-btn mr20" @click="$emit('close')">取消</el-button>
			<el-button type="primary"  class="action-btn ml20" @click="handleOnSubmit">确认</el-button>
		</div>
    </div>
</template>

<script>
import DefaultForm from './defaultForm.vue';
import DateForm from './dateForm.vue'
import DateDimensionForm from './dateDimensionForm.vue'
import { DIMENSION_DATE_FORM, DIMENSION_TYPE_DATA, DIMENSION_DATE_DIMENSION_FORM } from '../../constant'
export default {
    name: 'DimensionEditModal',
    props: [ 'dimension', 'cbs', 'fieldsCheckList', 'flatFieldsList' ],
    computed: {
        dimensionModal() {
            return this.dimension.modalData
        },
        componentName() {
            const name = this.dimension.name;
            switch (true) {
                case DIMENSION_DATE_FORM.includes(name):
                    return DateForm;
                case DIMENSION_DATE_DIMENSION_FORM.includes(name):
                    return DateDimensionForm;
                default:
                    return DefaultForm;
            }
           
        },
        optionFieldsList() {
            const names = this.fieldsCheckList.map(v=>v.name);
            return [].concat(
                this.fieldsCheckList, 
                this.flatFieldsList.filter(item=>!names.includes(item.name))
            )
        }
    },
    methods: {
        async handleOnSubmit() {
            const data = await this.$refs.componentRef.getFormData()
            this.cbs.onSubmit(data);
        }
    }
}
</script>

<style lang="scss" scoped>


</style>